import { render, staticRenderFns } from "./overflow.vue?vue&type=template&id=24bf4d2b&scoped=true"
import script from "./overflow.vue?vue&type=script&lang=js"
export * from "./overflow.vue?vue&type=script&lang=js"
import style0 from "./overflow.vue?vue&type=style&index=0&id=24bf4d2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf4d2b",
  null
  
)

export default component.exports